import React, { useContext } from "react";
import { Range, getTrackBackground } from "react-range";

import { LanguageContext, ThemeContext } from "contexts";
import { Theme, TText } from "api/type";

interface RangeSliderProps {
  metaData: any;
  values: number[];
  min: number;
  max: number;
  onChange: (newValues: number[]) => void;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const text: TText = {
  less: {
    en: "Less",
    es: "Menos",
  },
  more: {
    en: "More",
    es: "Más",
  },
  smaller: {
    en: "Smaller",
    es: "Más pequeño",
  },
  larger: {
    en: "Larger",
    es: "Más grande",
  },
};

const ReactRange: React.FC<RangeSliderProps> = ({
  metaData,
  values,
  min,
  max,
  onChange,
}: RangeSliderProps) => {
  const theme = useContext<Theme | null>(ThemeContext);
  const language = useContext(LanguageContext);

  if (!language) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: metaData?.implant_size_in_cc ? 25 : 0,
      }}
    >
      <Range
        values={values}
        step={1}
        min={min}
        max={max}
        onChange={(newValues) => onChange(newValues)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "36px",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                  values,
                  colors: [`${theme ? theme.themeColor : "#1C646E"}`, "#ccc"],
                  min,
                  max,
                }),
                alignSelf: "center",
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "28px",
              width: "28px",
              borderRadius: "28px",
              backgroundColor: "#FFF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 2px 6px #AAA",
              outlineColor: "#FFF",
            }}
          >
            {metaData?.implant_size_in_cc && (
              <div
                style={{
                  position: "absolute",
                  top: "-25px",
                  backgroundColor: "#000",
                  width: 32.75,
                  padding: 2,
                  borderRadius: 3,
                  fontSize: 11.5,
                  color: "#fff",
                  textAlign: "center",
                }}
              >
                {Math.round(
                  (values[0] * metaData?.implant_size_in_cc) / max / 25,
                ) *
                  25 +
                  "cc"}
              </div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default ReactRange;
